<template>
  <div>
    <vue-editor
      :value="localValue"
      @input="(val) => getContent(val)"
      useCustomImageHandler
      @image-added="handleImageAdded"
    ></vue-editor>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  components: {
    VueEditor,
  },
  data() {
    return {
      localValue: this.value || "",
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        const nextValue = val || "";
        if (nextValue !== this.localValue) {
          this.localValue = nextValue;
        }
      },
    },
  },
  methods: {
    getContent(val) {
      const nextValue = val || "";
      if (nextValue !== this.localValue) {
        this.localValue = nextValue;
      }
      if (nextValue !== this.value) {
        this.$emit("input", nextValue);
      }
    },
    async handleImageAdded(file, Editor, cursorLocation) {
      var formData = new FormData();
      formData.append("file", file);
      const res = await this.$http.post("/upload", formData);
      Editor.insertEmbed(cursorLocation, "image", res.data.url);
      //获取光标位置
      let length = Editor.selection.savedRange.index;
      //把光标位置 移动内容后面
      Editor.setSelection(length + 1);
      this.$message.success("上传成功");
    },
  },
};
</script>

<style>
</style>
